import type { UserEditableFormControlElement } from "../utils/types";

export class VisibleFieldMap {
    private map = new WeakMap<UserEditableFormControlElement, UserEditableFormControlElement>();

    set(original: UserEditableFormControlElement, visible: UserEditableFormControlElement): void {
        this.map.set(original, visible);
    }

    get(field: UserEditableFormControlElement): UserEditableFormControlElement {
        return this.map.get(field) ?? field;
    }
}
